import {IDataModelTypeConfig} from "frontend/dataModels/types/IDataModelTypeConfig";

export const UserDataModelTypeConfig: IDataModelTypeConfig = {
  fields: [

  ],
  subscriptions: {

  },
  defaultColumns: [
  
  ],
  columnConfig: {

  }
}